import { render, staticRenderFns } from "./SiestaHint.vue?vue&type=template&id=60108d55&scoped=true&"
import script from "./SiestaHint.vue?vue&type=script&lang=js&"
export * from "./SiestaHint.vue?vue&type=script&lang=js&"
import style0 from "./SiestaHint.vue?vue&type=style&index=0&id=60108d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60108d55",
  null
  
)

export default component.exports